<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="margin-bottom: 25px">
      <section class="d-flex justify-content-between">
        <div class="d-flex align-items-center mb-2">
          <div class="section-title">{{ $t("MACCS Movie List") }}</div>

          <div class="px-2 d-flex" style="gap: 10px">
            <input
              style="height: 40px"
              required
              autofocus
              type="search"
              :placeholder="$t('Search File')"
              class="form-control form-control-sm"
              v-model="searchCinema"
              v-debounce:300="onSearchFile"
            />
            <b-dropdown
              :text="filter_is_active_label"
              variant="dropdown-curve"
              class="ml-auto mr-3 filter-status-dropdown"
            >
              <b-dropdown-item @click="onChangeFilterIsActive('')"
                >All</b-dropdown-item
              >
              <b-dropdown-item @click="onChangeFilterIsActive('Y')"
                >Maccs Enabled</b-dropdown-item
              >
              <b-dropdown-item @click="onChangeFilterIsActive('N')"
                >Maccs Disabled</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>

        <div class="mx-2 justify-self-end">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </section>

      <div class="swc-report">
        <table class="swc-report-table mb-3" border="1">
          <thead>
            <tr>
              <th>{{ $tc("Sr. No.") }}</th>
              <th>{{ $tc("Movie Name") }}</th>
              <th
                v-if="
                  $can('create', 'MACCS Movie Status') ||
                  $can('update', 'MACCS Movie Status')
                "
              >
                {{ $tc("Maccs Status") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(macsValue, macsIndex) in macsData"
              :key="macsIndex"
              class="light_grey_back"
            >
              <td style="text-align: right">{{ macsIndex + 1 }}</td>
              <td
                :style="macsValue.macs_status == 'N' ? 'color:red' : ''"
                style="text-align: left"
              >
                {{ macsValue.movie_name }}
              </td>
              <td
                v-if="
                  $can('create', 'MACCS Movie Status') ||
                  $can('update', 'MACCS Movie Status')
                "
              >
                <b-form-checkbox
                  :disabled="!$can('update', 'MACCS Movie Status')"
                  v-model="macsValue.macs_status"
                  value="Y"
                  unchecked-value="N"
                  class="j-checkbox"
                  @change="openConfirmationPopup(macsValue)"
                />
              </td>
            </tr>
          </tbody>
          <tbody v-if="macsData.length == 0">
            <tr>
              <td colspan="13">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        <b-modal
          id="confirmation"
          title="Change the MACCS status?"
          hide-footer
          hide-header-close
          no-close-on-backdrop
        >
          <div class="text-center pb-1">
            <p class="fs-16 mb-2">
              Are you sure you want to change the maccs status of
              {{ tempDataMacsStatus.movie_name }}?
            </p>

            <button class="btn-outline-blue" @click="cancelStatusUpdate()">
              Cancel
            </button>
            <span class="mx-1"></span>
            <button
              class="btn btn-danger btn-danger-lg px-4 fs-14"
              @click="changeMacsStatus()"
            >
              Confirm
            </button>
          </div>
        </b-modal>
      </div>

      <div class="d-flex justify-content-between mb-2 align-items-center">
        <div class="d-flex justify-content-end align-items-center">
          <b-pagination
            v-if="macsData.length > 0"
            v-model="currentPage"
            :total-rows="rows"
            @change="onChangePagination($event)"
            :per-page="perPage"
            aria-controls="my-table"
            class="my-1"
          ></b-pagination>
        </div>

        <div
          v-if="macsData.length > 0"
          class="d-flex justify-content-end align-items-center"
        >
          <div>{{ $t("download") }} as :</div>
          <a
            :href="
              BASE_URL +
              `/api/admin/getmovieslistExcel?schedule=&type=Recent&cinema_id=&isExcel='Y'&macs_status=${this.listType}`
            "
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import scheduleService from "@/services/scheduleService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";

export default {
  components: { DatePicker, Multiselect, NoRecords, FilterByStatusDropdown },
  data() {
    return {
      macsData: [],
      tempData: [],
      tempAllData: [],
      macsSearch: "",

      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      reservationList: [],
      reservationListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchReservationDetail: {
        date: "",
        cinema_id: null,
        ssb_code: "",
        show_date: "",
        show_date_to: null,
        from_date: "",
        to_date: null,
      },
      filterkey: "",
      filtervalue: "",
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      sendMailObj: [],
      currencyData: "",
      maccs_enabled: [],
      maccs_disabled: [],

      searchReservations: "",
      listType: "",
      filter_is_active_label: "All",
      tempDataMacsStatus: {},
      finalSaveArr: [{ md_id: "", macs_status: "" }],
    };
  },
  beforeMount() {
    this.getMacsLog();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMacsLog();
      } else {
        this.currentPage = event;
        this.getMacsLog();
      }
    },
    openConfirmationPopup(e) {
      console.log("hhhhhhhhh");
      this.tempDataMacsStatus = e;
      this.$bvModal.show("confirmation");
    },
    cancelStatusUpdate() {
      let findIndexData = this.macsData.findIndex((x) => {
        return x.md_id == this.tempDataMacsStatus.md_id;
      });
      if (findIndexData >= 0) {
        this.macsData[findIndexData]["macs_status"] =
          this.tempDataMacsStatus.macs_status == "Y" ? "N" : "Y";
      }
      this.$bvModal.hide("confirmation");
    },
    changeMacsStatus() {
      scheduleService
        .UpdateMoviesMaccsStatus({ finalSaveArr: [this.tempDataMacsStatus] })
        .then((response) => {
          const { data } = response;
          console.log("data", data.status);
        });
      this.$bvModal.hide("confirmation");
      this.getMacsLog();
    },
    onChangeFilterIsActive(type) {
      if (type == "Y") {
        this.filter_is_active_label = "Maccs Enabled";
      } else if (type == "N") {
        this.filter_is_active_label = "Maccs Disabled";
      } else {
        this.filter_is_active_label = "All";
      }
      this.listType = type;
      this.currentPage = 1;

      this.getMacsLog();
    },
    showFile(obj) {
      window.open(obj.maccs_upload_path);
    },

    getMacsLog: function () {
      let loader = this.$loading.show();
      scheduleService
        .GetMoviesDD({
          title: "",
          tab: "Recent",
          cinema_id: null,
          limit: this.perPage,
          currentPage: this.currentPage,
          maccs_search: this.searchCinema,
          macs_status_filter: this.listType,
          orderBy: "md.macs_status",
        })
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data && data.status && data.MovieListResult.length > 0) {
            this.maccs_enabled = data.MovieListResult.filter(
              (x) => x.macs_status == "Y"
            );
            this.maccs_disabled = data.MovieListResult.filter(
              (x) => x.macs_status == "N"
            );
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }

            this.macsData = data.MovieListResult;
            this.tempData = [...this.maccs_enabled, ...this.maccs_disabled];
            this.tempAllData = [...this.maccs_enabled, ...this.maccs_disabled];
            console.log("this.macsData", this.macsData);
          } else {
            this.macsData = [];
            this.tempData = [];
            this.tempAllData = [];
            this.maccs_enabled = [];
            this.maccs_disabled = [];
            console.log("data.message :", data.message);
          }
        });
    },
    onSearchFile: function (value) {
      this.currentPage = 1;
      this.getMacsLog();
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
.icon-size {
  padding-top: 14px;
  padding-bottom: 14px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/Macs/maccs_movie_list.vue